import MockAdapter from 'axios-mock-adapter'

export default function create(instance) {
  // This sets the mock adapter on the default instance
  const adapter = new MockAdapter(instance, { delayResponse: 250 })
  require('../requests/app').mock(adapter)
}


// WEBPACK FOOTER //
// ./src/api/mock/config/configure.js